import { render } from "./Constructions.vue?vue&type=template&id=00f63915"
import script from "./Constructions.vue?vue&type=script&lang=js"
export * from "./Constructions.vue?vue&type=script&lang=js"
script.render = render

export default script